///
/// EarthBrowser
///
/// Created by Matt Giger on 9/23/2026
/// Copyright (c) 2026 Geodata Labs
///
/// "Recent" list for the Views menu: rows re-run a recently used command
/// (fly to a place, refocus a satellite, toggle a tool...). Persisted
/// recents are resolved back into runnable commands by useRecentItems.
///

import { cn } from "@/utils/utils"
import type { CommandItem } from "../layers-panel/commandTypes"

interface RecentsListProps {
	items: CommandItem[]
	/** Run the command (records the recent + closes the menu) */
	onRun: (cmd: CommandItem) => void
}

export function RecentsList({ items, onRun }: RecentsListProps) {
	if (items.length === 0) {
		return (
			<p className="px-2 py-3 text-xs text-white/40 text-center">
				Places, satellites and actions you use will show up here
			</p>
		)
	}

	return (
		<div className="flex-1 min-h-0 overflow-y-auto">
			{items.map(command => (
				<button
					key={command.id}
					onClick={() => onRun(command)}
					className={cn(
						"w-full flex items-center gap-2.5 px-2 py-1.5 rounded-lg text-left",
						"hover:bg-white/10 active:bg-white/20 transition-colors duration-200",
						"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
					)}
				>
					<div className="flex items-center justify-center p-1 rounded-lg bg-slate-500/10 border border-slate-500/20 flex-shrink-0">
						{command.icon}
					</div>
					<div className="flex-1 min-w-0">
						<div className="text-sm text-white/85 truncate">{command.title}</div>
						{command.subtitle && (
							<div className="text-[10px] text-white/40 truncate">{command.subtitle}</div>
						)}
					</div>
				</button>
			))}
		</div>
	)
}
